import { InAppState } from "../base/InAppState";
import '../../components/pack/pack-card';
import template from './PackListTemplate.html';

import { Pack } from "../../models/Pack";

export class PackListState extends InAppState
{
    static ROUTE = '/pack/list';
    static ID = 'pack-list';

    async enter()
    {
        this.packs = [];
        this.currentFilter = 'all';
        const { result } = await this.app.api.get( '/pack' );
        if ( result.status === 200 && result.data.length > 0 )
        {
            result.data.forEach( ( pack ) =>
            {
                this.packs.push( new Pack( pack ) );
            });
        }

        this.render();
        this._bindCards();
        this._bindFilterNavigation();
        this._bindCreatePackButtons();
        this._bindPremiumModal();

        this.addEventListener(
            this.app.view.pageContent,
            'delete',
            ( e ) => {
                if ( e.detail?.packId )
                {
                    this.deletePack( e.detail.packId );
                }
            }
        );
    }

    _bindCards()
    {
        const filteredPacks = this._getFilteredPacks();
        const cards = this.app.view.pageContent.querySelectorAll( 'pack-card' );
        cards.forEach( ( card, index ) => {
            if ( filteredPacks[ index ] )
            {
                card.pack = filteredPacks[ index ];
            }
        });
    }

    _bindFilterNavigation()
    {
        const filterLinks = this.app.view.pageContent.querySelectorAll( '[data-filter]' );
        filterLinks.forEach( ( link ) => {
            this.addEventListener( link, 'click', ( e ) => {
                e.preventDefault();
                const filter = link.dataset.filter;
                if ( filter !== this.currentFilter )
                {
                    this.currentFilter = filter;
                    this.render();
                    this._bindCards();
                    this._bindFilterNavigation();
                    this._bindCreatePackButtons();
                    this._bindPremiumModal();
                }
            });
        });
    }

    _getFilteredPacks()
    {
        if ( this.currentFilter === 'all' )
        {
            return this.packs;
        }
        const statusFilter = this.currentFilter.toUpperCase();
        return this.packs.filter( ( pack ) => pack.status === statusFilter );
    }

    async deletePack( packId )
    {
        const performDeletion = await this.app.view.confirm(
            "Delete Pack",
            "Do you really want to delete this pack?"
        );

        if ( true === performDeletion )
        {
            const pageContent = this.app.view.pageContent;
            this.app.view.blockUI( pageContent, 'Deleting pack...' );

            const { result } = await this.app.api.delete( `/pack/${packId}` );

            this.app.view.unblockUI( pageContent );

            if ( result.status === 200 )
            {
                this.app.view.toast( "Pack deleted successfully", "success" );
                const idxToDelete = this.packs.findIndex( ( pack ) => pack.id === packId );
                if ( idxToDelete > -1 )
                {
                    this.packs.splice( idxToDelete, 1 );
                }
                this.render();
                this._bindCards();
                this._bindFilterNavigation();
                this._bindCreatePackButtons();
                this._bindPremiumModal();
            }
            else
            {
                this.app.view.toast( "Pack deletion failed", "error" );
            }
        }
    }

    _hasPackAccess()
    {
        const planId = this.app.organisation?.premium?.id;
        return planId === 'BUSINESS' || planId === 'ENTERPRISE';
    }

    _bindCreatePackButtons()
    {
        this.app.view.pageContent.querySelectorAll( '[data-type="create-pack-btn"]' ).forEach( ( btn ) =>
        {
            this.addEventListener( btn, 'click', ( e ) =>
            {
                e.preventDefault();
                if ( this._hasPackAccess() )
                {
                    this.app.router.redirect( '/pack/create' );
                }
                else
                {
                    this._showModal( 'premiumRequiredModal' );
                }
            });
        });
    }

    _bindPremiumModal()
    {
        const closeBtn = this.app.view.pageContent.querySelector( '[data-type="premium-modal-close"]' );
        const cancelBtn = this.app.view.pageContent.querySelector( '[data-type="premium-modal-cancel"]' );
        const upgradeBtn = this.app.view.pageContent.querySelector( '[data-type="premium-modal-upgrade"]' );

        if ( closeBtn )
        {
            this.addEventListener( closeBtn, 'click', () => this._hideModal( 'premiumRequiredModal' ) );
        }

        if ( cancelBtn )
        {
            this.addEventListener( cancelBtn, 'click', () => this._hideModal( 'premiumRequiredModal' ) );
        }

        if ( upgradeBtn )
        {
            this.addEventListener( upgradeBtn, 'click', () =>
            {
                this._hideModal( 'premiumRequiredModal' );
                this.app.router.redirect( '/premium' );
            });
        }
    }

    _showModal( modalId )
    {
        const modal = this.app.view.pageContent.querySelector( `#${modalId}` );
        if ( modal )
        {
            modal.classList.add( 'show' );
            modal.style.display = 'block';
            document.body.classList.add( 'modal-open' );

            const backdrop = document.createElement( 'div' );
            backdrop.className = 'modal-backdrop fade show';
            backdrop.id = `${modalId}Backdrop`;
            document.body.appendChild( backdrop );
        }
    }

    _hideModal( modalId )
    {
        const modal = this.app.view.pageContent.querySelector( `#${modalId}` );
        const backdrop = document.getElementById( `${modalId}Backdrop` );

        if ( modal )
        {
            modal.classList.remove( 'show' );
            modal.style.display = 'none';
            document.body.classList.remove( 'modal-open' );
        }

        if ( backdrop )
        {
            backdrop.remove();
        }
    }

    render()
    {
        this.app.view.render(
            this.app.view.pageContent,
            template,
            {
                packs : this._getFilteredPacks(),
                currentFilter : this.currentFilter,
                totalCount : this.packs.length
            }
        );
    }

    getContentHeaderData()
    {
        return {
            title: 'Packs',
            breadcrumb: [ 'Work', 'List of packs' ]
        };
    }
}
